/**
 * Copyright IBM Corp. 2022, 2026
 */

import MarketoForm from 'components/marketo-form'
import datoURLToAssetSubdir from 'lib/formatting/dato-url-to-asset-subdir'
import s from './style.module.css'

type TAppearance = 'light' | 'dark'

interface OnDemandFormProps {
	formTitle: string
	contentLength?: string
	buttonCtaText?: string
	marketoFormId: number
	targetLink: $TSFixMe
	appearance?: TAppearance
	contentType: string
}

export default function OnDemandForm({
	formTitle,
	contentLength,
	buttonCtaText,
	marketoFormId,
	targetLink,
	appearance = 'light',
	contentType,
}: OnDemandFormProps) {
	function handleSubmit() {
		const target = targetLink
		let redirectDestination

		// White papers have their own external URL, other types (blog, resource) redirect internally
		// and OnDemandDestinationUrl redirect to any arbitrary URL
		if (target.__typename === 'WhitePaperRecord') {
			redirectDestination = datoURLToAssetSubdir(target.file.url)
		} else if (target.__typename === 'OnDemandDestinationUrlRecord') {
			redirectDestination = target.url
		} else {
			redirectDestination = `/${getTypePath(target.__typename) + target.slug}`
		}

		window.open(redirectDestination, '_blank')
		window.location.href = '/thank-you/on-demand'
	}

	return (
		<div className={s.onDemandForm} data-theme={appearance}>
			<div className={s.formHeader}>
				<p className={s.formTitleMobile}>
					Complete this form to access your {contentType}
				</p>
				<p className={s.formTitleDesktop}>{formTitle}</p>
				{contentLength && (
					<div className={s.onDemandDate}>
						<span>{contentLength}</span>
					</div>
				)}
			</div>
			<MarketoForm
				className={s.formStyles}
				formId={marketoFormId.toString()}
				submitTitle={buttonCtaText}
				onSubmitSuccess={handleSubmit}
				onSubmitError={handleSubmit}
			/>
		</div>
	)
}

// Used to generate the appropriate redirect URL after successful submission
function getTypePath(type) {
	switch (type) {
		case 'BlogPostV2Record':
			return 'blog/'
		case 'ResourceRecord':
			return 'resources/'
		case 'ResourceV2Record':
			return 'resources/'
		default:
			// Template pages are at the root https://hashicorp.com/name-of-page
			return ''
	}
}
